/* src/app/canvas-view/canvas-view.component.css */
/*# sourceMappingURL=canvas-view.component-X7JITGCS.css.map */
